export class ClientAgreementDocumentBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  documentId: string;
  clientId: string;
  agencyId: string;
  documentValue: ClientAgreementDocumentMergedBO;
}

/////////////////////////////////////// CLIENT DOCUMENTBO /////////////////////////////////////////

export class ClientAgreementDocumentMergedBO {
  id:string;
  release_of_InformationDocumentBO: Release_of_InformationDocumentBO = new Release_of_InformationDocumentBO();
  employerOrPayerAppointmentOfAgentDocumentBO: EmployerOrPayerAppointmentOfAgentDocumentBO = new EmployerOrPayerAppointmentOfAgentDocumentBO();
  application_Employer_Identification_NumberDocumentBO: Application_Employer_Identification_NumberDocumentBO = new Application_Employer_Identification_NumberDocumentBO();
  participantAgreementDocumentBO: ParticipantAgreementDocumentBO = new ParticipantAgreementDocumentBO();
  individual_Sole_Proprietor_OfAttornyDocumentBO: Individual_Sole_Proprietor_OfAttornyDocumentBO = new Individual_Sole_Proprietor_OfAttornyDocumentBO();
}

export class Release_of_InformationDocumentBO {
  participantName: string;
  agencyName: string;
  others: string;
  authorizeBestCare: any;
  sign: string;
  signDate: string | null;
}

export class EmployerOrPayerAppointmentOfAgentDocumentBO {
  agentEmployerIndentificationNumber: string;
  agenctsName: string;
  agentTradeName: string;
  agentStreet: string;
  agentSuiteOrRoomNumber: string;
  agentCity: string;
  agentState: string;
  agentZip: string;
  agentTitleLid:string;
  agenctNumber:string;
  number:string;
  agenct_ifyou_are_home_care_service_recipient: string;
  agentSign: string;
  agentSignDate: string | null;
  agentTypeName: string;
  titleName: string;
  agentDayTimePhone: string;
  employeeIndentificationNumber: string;
  employersOrPayerName: string;
  tradeName: string;
  street: string;
  suiteOrRoomNumber: string;
  city: string;
  state: string;
  zip: string;
  futaForAll: boolean;
  futaForSome: boolean;
  employersQuarterlyFederalTaxForAll: boolean;
  employersQuarterlyFederalTaxForSome: boolean;
  employersAnnualFederalTaxReturnForAll: boolean;
  employersAnnualFederalTaxReturnForSome: boolean;
  employersAnnualFederalIncomeReturnForAll: boolean;
  employersAnnualFederalIncomeReturnForSome: boolean;
  annualReturnofWithheldFederalIncomeTaxForAll: boolean;
  annualReturnofWithheldFederalIncomeTaxForSome: boolean;
  employersAnnualRailroadRetirementTaxReturnForAll: boolean;
  employersAnnualRailroadRetirementTaxReturnForSome: boolean;
  employeeRepresentativesQuarterlyRailroadTaxReturnForAll: boolean;
  employeeRepresentativesQuarterlyRailroadTaxReturnForSome: boolean;
  ifyou_are_home_care_service_recipient: boolean;
  sign: string;
  signDate: string | null;
  typeName: string;
  dayTimePhone: string;
  appointorRevoke: string | null;
  titleLid: string | null;
}

export class Application_Employer_Identification_NumberDocumentBO {
  agencyName: string;
  agencyMailingAddress: string;
  agencyStreet: string;
  agencyCity_state_zip: string;
  agencyCity_state_zipIdifferent: string;
  agencyCounty: string;
  nameofResponsibleParty: string;
  ssn: string;
  isapplicationLlc: any;
  ifYesnumberofLlcMembers: string;
  isllc_Organized_UnitedStates: any;
  solepropritor_Ssn: string;
  typeofEntity: string;
  corporationNumber: string;
  otherNonProfitOrgText: string;
  other_9aText: string;
  estate_Ssn: string;
  planAdministrator_Tin: string;
  trust_Tin: string;
  genIfAny: string;
  state_9b: string;
  foreignCountry: string;
  startedNewbusinessSpecifyType: string;
  reasonForAppling: string;
  backingPurposeSpecifyType: string;
  changedTypeOrgType: string;
  createdTrustSpecifyType: string;
  createdPensionPlanSpecifyType: string;
  other_10_specify: string;
  dateofBusinessStarted: string | null;
  closingMonth: string;
  no_of_employees_Agriculture: string;
  no_of_employees_HouseHold: string;
  no_of_employees_other: string;
  file_Form_941_every_quarter: boolean;
  first_date_wages_Annuities_were_paid: string | null;
  pricipalActivities: string;
  indicate_Principle_line: string;
  isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein: any;
  applicant_entity_shown_line1_everapplied_for_and_received_an_EIN_if_yes: string;
  designeesName: string;
  designees_Address_ZipCode: string;
  under_penalties_of_perjury_Name_title: string;
  signature: string;
  date: string | null;
  designees_telephone_number: string;
  designees_Fax_Number: string;
  applicants_Telephone_Number: string;
  applicants_Fax_Number: string;
  under_penalties_of_perjury_Name_titleLid: string | null;
  other_Specify1: string;
  othertext_16: string;
  purchaseedGoingBusinesstext: string;
  agencyCity_state_zipIdifferent1: string;
  einnumber: string;
  tradename: string;
  legalname: string;
}

export class ParticipantAgreementDocumentBO {
  agencyName: string;
  fmsAct: string;
  cdcsBudgetwithStaffing: number | null;
  cdcsBudgetwithGoods: number | null;
  csgBudget: number | null;
  clientName: string;
  participantSign1: string;
  participantSign2: string;
  effectivedate: string | null;
  participantSign2Date: string | null;
}

export class Individual_Sole_Proprietor_OfAttornyDocumentBO {
  taxpayerName: string;
  street_Addres_or_PoBox: string;
  social_Security_number_or_Itin: string;
  minnesota_or_Federal_Employer_Identification_Number: string;
  apt_or_Suit: string;
  phoneNumber: string;
  faxNumber: string;
  city: string;
  state: string;
  zipCode: string;
  emailAddress: string;
  name_of_Appointee: string;
  primary_Appointee_Street_Address_or_PoBox: string;
  primary_Appointee_Apt_or_Suite: string;
  primary_Appointee_Attorney_Number_Accountant_Number_or_Ptin: string;
  primary_Appointee_PhoneNumber: string;
  primary_Appointee_FaxNumber: string;
  primary_Appointee_city: string;
  primary_Appointee_state: string;
  primary_Appointee_Zipcode: string;
  primary_Appointee_EmailAddress: string;
  lLmitedAthourity: string;

  authority_Granted_Type_of_Tax1: string;
  authority_Granted_Type_of_Tax2: string;
  authority_Granted_Type_of_Tax3: string;
  years_of_Periods1: string;
  years_of_Periods2: string;
  years_of_Periods3: string;
  years_of_Periods4: string;
  authority_Experiation_Date: string | null;
  communicate_with_the_department_by_email: boolean;
  sign_returns_and_other_tax_forms: boolean;
  extend_statute_of_limitations_to_assess_tax: boolean;
  excute_Agreements: boolean;
  add_additional_appointees: boolean;
  receive_all_mail_except_refunds: boolean;
  act_on_my_behalf_i_became_incapacitated_or_incompetent: boolean;
  authorize_the_department_to_release_return_information_third_parties: boolean;
  signature: string;
  signatureDate: string | null;
  address_If_Different_from_Taxpayer: string;
  print_Name_and_If_applicable: string;
  chooseTitleLid: string | null;
  signPhoneNumber: string;
  signature_City: string;
  signature_State: string;
  signature_Zipcode: string;
  additional_appointee_Form1_Name_of_Taxpayer: string;
  additional_appointee_Form1_SsN_Itin_Mn_Id_or_Fein: string;
  agencyName: string;
  additional_appointeeAddress: Additional_AppointeeAddressDocumentBO[] = [];
}

export class Additional_AppointeeAddressDocumentBO {
  nameofAppointee: string;
  street_Address_or_PoBox: string;
  apt_or_Suite: string;
  attorneyNumber_AccountantNumber_or_Ptin: string;
  phoneNumber: string;
  faxNumber: string;
  city: string;
  zip: string;
  state: string;
  email: string;
}

////////////////////////////////// SENT TO CLIENTBO////////////////////////
export class SendToUserBO {
  id: string;
  clientId: string;
  agencyNote: string;
  statusLid: string;
  portalLink: string;
  documentLid: string;
  agencyid: string;
  documentValue: ClientAgreementDocumentMergedBO;
}

///////////////////////////////////// COMPLETEBO //////////////////////////////
export class CompleteBo {
  id: string;
  clientId: string;
  documentValue: ClientAgreementDocumentMergedBO;
}

export class SubmitClientAggremntBo {
  aggrementId: string;
  type: string;
}
